import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';

const SatisfactionPanelShared = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    const fetch_ = async () => {
      try {
        const r = await axios.get(`${API}/api/admin/satisfaction-stats`, { withCredentials: true });
        setData(r.data);
      } catch (e) { console.error(e); }
      setLoading(false);
    };
    fetch_();
  }, []);

  if (loading) return <p className="text-white/40">Cargando datos de satisfaccion...</p>;
  if (!data) return <p className="text-white/40">Error cargando datos.</p>;

  const stats = data.stats || {};
  const ratings = (data.ratings || []).filter(r => {
    if (filter === 'low') return r.rating <= 5;
    if (filter === 'high') return r.rating > 5;
    if (filter === 'free') return r.ai_mode === 'free';
    if (filter === 'paid') return r.ai_mode === 'paid';
    return true;
  });
  const dist = stats.distribution || {};

  return (
    <div data-testid="satisfaction-panel">
      <h2 className="text-2xl font-bold mb-6">Satisfaccion del Chat</h2>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="glass-card p-4 text-center" data-testid="satisfaction-avg">
          <p className={`text-3xl font-bold ${stats.average >= 7 ? 'text-green-400' : stats.average >= 5 ? 'text-yellow-400' : 'text-red-400'}`}>
            {stats.average || 0}
          </p>
          <p className="text-xs text-white/50">Promedio</p>
        </div>
        <div className="glass-card p-4 text-center">
          <p className="text-3xl font-bold">{stats.total || 0}</p>
          <p className="text-xs text-white/50">Total Calificaciones</p>
        </div>
        <div className="glass-card p-4 text-center">
          <p className="text-3xl font-bold text-red-400">{stats.low_count || 0}</p>
          <p className="text-xs text-white/50">Bajas (1-5)</p>
        </div>
        <div className="glass-card p-4 text-center">
          <p className="text-xs text-white/40 mb-1">Por Modo AI</p>
          <p className="text-sm"><span className="text-green-400">Free: {stats.free_avg || 0}</span> / <span className="text-orange-400">Paid: {stats.paid_avg || 0}</span></p>
        </div>
      </div>

      {stats.total > 0 && (
        <div className="glass-card p-4 mb-6">
          <p className="text-xs text-white/40 mb-3">Distribucion de Calificaciones</p>
          <div className="flex items-end gap-1 h-24">
            {[1,2,3,4,5,6,7,8,9,10].map(n => {
              const count = dist[String(n)] || 0;
              const maxCount = Math.max(...Object.values(dist).map(Number), 1);
              const pct = (count / maxCount) * 100;
              return (
                <div key={n} className="flex-1 flex flex-col items-center gap-1">
                  <div className={`w-full rounded-t transition-all ${n <= 5 ? 'bg-red-500/60' : 'bg-green-500/60'}`} style={{ height: `${Math.max(pct, 4)}%` }} />
                  <span className="text-[9px] text-white/30">{n}</span>
                  <span className="text-[9px] text-white/50">{count}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div className="flex gap-2 mb-4">
        {['all', 'low', 'high', 'free', 'paid'].map(f => (
          <button key={f} onClick={() => setFilter(f)}
            className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${filter === f ? 'bg-[#E8720C] text-white' : 'bg-white/5 text-white/50 hover:bg-white/10'}`}
            data-testid={`satisfaction-filter-${f}`}>
            {f === 'all' ? 'Todos' : f === 'low' ? 'Bajas (1-5)' : f === 'high' ? 'Altas (6-10)' : f === 'free' ? 'AI Free' : 'AI Paid'}
          </button>
        ))}
      </div>

      <div className="space-y-2">
        {ratings.length === 0 ? (
          <p className="text-white/30 text-sm text-center py-8">Sin calificaciones aun.</p>
        ) : ratings.map((r, i) => (
          <div key={i} className={`glass-card p-4 flex items-start gap-4 ${r.rating <= 5 ? 'border-l-2 border-red-500' : ''}`} data-testid={`satisfaction-item-${i}`}>
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center font-bold text-lg shrink-0 ${
              r.rating <= 5 ? 'bg-red-500/15 text-red-400' : r.rating <= 7 ? 'bg-yellow-500/15 text-yellow-400' : 'bg-green-500/15 text-green-400'
            }`}>{r.rating}</div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 text-xs text-white/40 mb-1">
                <span>{r.name || 'Anonimo'}</span>
                {r.email && <span className="text-white/20">({r.email})</span>}
                <span className={`px-1.5 py-0.5 rounded text-[9px] ${r.ai_mode === 'paid' ? 'bg-orange-500/15 text-orange-400' : 'bg-green-500/15 text-green-400'}`}>
                  {r.ai_mode || 'desconocido'}
                </span>
                <span className="ml-auto">{r.created_at ? new Date(r.created_at).toLocaleDateString() : ''}</span>
              </div>
              {r.comment && <p className="text-sm text-white/60">{r.comment}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SatisfactionPanelShared;
